/**
 * Logique de tirage de la roue quotidienne (pure, testable).
 *
 * Règles produit (décision client, cf. PLAN.md G4) :
 * - 1ᵉʳ tour de roue de l'utilisateur (aucune ligne `wheel_spins` ni
 *   `contest_entries`) → cadeau GARANTI (qualification au tirage au sort).
 * - Tours suivants : 40 % cadeau / 60 % points.
 *
 * La fonction est pure : le générateur aléatoire est injectable pour les
 * tests (cf. tests/wheel.test.ts).
 */

export type WheelOutcome = "gift" | "points";

/** Probabilité de tomber sur un cadeau après le premier tour. */
export const GIFT_PROBABILITY = 0.4;

/**
 * Détermine le résultat logique d'un tour de roue.
 *
 * @param isFirstSpin vrai si l'utilisateur n'a encore AUCUN tour enregistré
 *   (wheel_spins) NI participation au tirage (contest_entries)
 * @param rng générateur uniforme sur [0, 1) — Math.random par défaut
 */
export function pickWheelOutcome(
  isFirstSpin: boolean,
  rng: () => number = Math.random
): WheelOutcome {
  if (isFirstSpin) return "gift";
  return rng() < GIFT_PROBABILITY ? "gift" : "points";
}
